import React from 'react';
import { connect } from 'react-redux';
import { loginUser } from '../redux/actions/users';
import { useState } from 'react';
import Authentication from '../components/Authentication';

function Login(props) {
  const [username, setUsername] = useState(props.username);
  const [email, setEmail] = useState(props.email);
  const [password, setPassword] = useState(props.password);

  const { loginUser } = props;

  const handleLogin = (e) => {
    e.preventDefault();

    const data = {
      username,
      email,
      password
    };

    console.log(e);
    console.log(data);
    loginUser(data);
  };
  return (
    <div>
      <Authentication
        question="Belum Punya Akun?"
        auth="Daftar"
        link="/register"
        text1="Login"
        text2="Masuk untuk menjelajahi berbagai fitur menarik"
        text3="Masuk"
        onInputUsername={(e) => setUsername(e.target.value)}
        onInputEmail={(e) => setEmail(e.target.value)}
        onInputPassword={(e) => setPassword(e.target.value)}
        onSubmit={handleLogin}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  username: state.users.username,
  email: state.users.email,
  password: state.users.password
});

const mapDispatchToProps = (dispatch) => ({
  loginUser: (data) => dispatch(loginUser(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
